export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "";
export const GITHUB_LINK = "";
export const DONATION_LINK = "https://ko-fi.com/teamberga";
export const GA_ID = "G-44YVXRL61C";
export const BACKEND_URL = "https://backend.movie-web.app";
